import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mm-blog',
  templateUrl: './mm-blog.component.html',
  styleUrls: ['./mm-blog.component.css']
})
export class MmBlogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
